export default {
  api: {
    companyContact: {
      companyId: {
        notNull: "Select a company",
      },
      personId: {
        notNull: "Select a contact",
      },
      typeId: {
        notNull: "Select a relation type",
      },
    },
  },
}
